// libs
import React, { memo } from 'react';

// global components
import SubNav, { SUB_NAV_PLACEMENT } from 'shared/components/SubNav';

// components
import SubMenu from './components/SubMenu';

// constants
import { TEXTS } from './constants';

//Analytics
import * as Analytics from 'shared/components/Header/analytics';

// styles
import { AuthContainer, Icon, TextContainer } from './styles';

function Auth() {
  const onSubNavVisible = () => Analytics.onSignInClick();

  return (
    <SubNav subMenu={<SubMenu />} placement={SUB_NAV_PLACEMENT.RIGHT} onVisible={onSubNavVisible}>
      <AuthContainer>
        <Icon className="icon-bn-account" />
        <TextContainer>{TEXTS.ACCOUNT}</TextContainer>
      </AuthContainer>
    </SubNav>
  );
}

export default memo(Auth);
